import { Button } from '@/components/ui/button';
import type { CardComponentProps } from 'nextstepjs';
import { useTranslation } from 'react-i18next';

const OnboardingTourCard = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  skipTour,
  arrow,
  ...props
}: CardComponentProps) => {
  const { t } = useTranslation('onboarding');
  const i18nKey = (step.content as string) || 'welcome';
  const isFirst = currentStep === 0;
  const isLast = currentStep === totalSteps - 1;

  const _handleNext = () => {
    console.log('step', step);
    if (step.beforeNext) {
      step.beforeNext();
    }
    setTimeout(() => {
      nextStep();
    }, step.delay ?? 0);
  };

  return (
    <div className='bg-white dark:bg-stone-900 rounded-lg border border-slate-200 dark:border-stone-800 shadow-lg p-4 max-w-xs w-72'>
      {arrow}
      <div className='flex flex-col gap-3'>
        <div>
          <p className='text-xs text-slate-400 dark:text-stone-500 mb-1'>
            {currentStep + 1} / {totalSteps}
          </p>
          <h3 className='text-sm font-semibold text-slate-900 dark:text-white'>{t(`tour.${i18nKey}.title`)}</h3>
          <p className='text-sm text-slate-600 dark:text-stone-300 mt-1'>{t(`tour.${i18nKey}.description`)}</p>
        </div>
        <div className='flex items-center justify-between'>
          <button
            onClick={skipTour}
            className='text-xs text-slate-400 hover:text-slate-600 dark:text-stone-500 dark:hover:text-stone-300 transition-colors'>
            {t('controls.skip')}
          </button>
          <div className='flex gap-2'>
            {!isFirst && (
              <Button variant='outline' size='sm' onClick={prevStep}>
                {t('controls.prev')}
              </Button>
            )}
            <Button size='sm' onClick={_handleNext}>
              {isLast ? t('controls.finish') : t('controls.next')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingTourCard;
